import category from './category'
import insurance from './insurance'
import plugin from './plugin'
import remooc from './remooc'
import remoocCategory from './remooc-category'
import repair from './repair'
import vehicle from './vehicle'

export default {
  vehicle,
  category,
  insurance,
  plugin,
  remoocCategory,
  remooc,
  repair
}
